import React, { forwardRef, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";

import { UserContext } from "../../contexts/UserContext";

/*user Components*/
import "./User.css";
import UserInfo from "./userComponents/UserInfo";
import UserList from "./userComponents/UserList";
import UserTabs from "./userComponents/UserTabs";

const User = forwardRef((props) => {
  const user = useContext(UserContext);

  const [sysUser, setSysUser] = React.useState(0);

  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      useState,
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));
  const classes = useStyles();

  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  let history = useHistory();

  const requestUser = () => {
    const url =
      process.env.REACT_APP_API2_URL +
      "/User/Users_GetInfo?idUser=" +
      props.match.params.id;
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        setSysUser(data);
      });
  };

  useEffect(() => {
    requestUser();
  }, []);

  useEffect(() => {
    requestUser();
  }, [props.match.params.id]);

  const UpdateSysUser = (row) => {
    let userRequest = {
      userId: row.idUser,
      IdUserProfile: row.idUserProfile,
      IdDepartment: row.idDepartment,
      LoginName: row.loginName,
      Name: row.name,
      Status: row.status,
      IdLanguage: row.idLanguage,
      IdUser: userInfo.userId,
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/User/Users_Update",
      data: userRequest,
    }).then((response) => {
      if (Number(response.data) === -1) {
        alert("Error updating user");
      } else {
        alert("Data Successfully Updated");
      }
    });
  };

  const setCurrentUser = (user) => {
    console.log("in user props", props);
    console.log("in user props", user);
    setSysUser(user);
    let anothervar = user.idUser.toString();
    //let anothervar = 'user.Iduser';
    history.push(anothervar);
    console.log("in user props after anothervar", anothervar);
  };
  return (
    <React.Fragment>
      {console.log("in user props", props)}
      {user && (
        <>
          <div className="sticky top-0 flex-grow-0">
            <UserList
              showLoading={props.showLoading}
              setUser={setCurrentUser}
            ></UserList>
          </div>
          <div className="flex-1 pl-4 h-max">
            <Paper className={classes.root}>
              <div
                id="inputs"
                className="mb-3 text-lg font-semibold"
                style={{ display: "flex", maxHeight: 45 }}
              >
                {true ? (
                  <UserInfo
                    sysUser={sysUser}
                    UpdateSysUser={UpdateSysUser}
                  ></UserInfo>
                ) : (
                  <UserInfo
                    sysUser={sysUser}
                    UpdateSysUser={UpdateSysUser}
                  ></UserInfo>
                )}
              </div>

              <UserTabs
                AgentInfo={props.location}
                sysUser={sysUser}
                UpdateSysUser={UpdateSysUser}
                showLoading={props.showLoading}
              ></UserTabs>
            </Paper>
          </div>
        </>
      )}
    </React.Fragment>
  );
});

export default User;
